export default {
    tipoFaixa: {
        id: null,
        nome: '',
        ativo: true,
        lancaMensalidade: false,
        regraPrimeiraMensalidade: 'INTEGRAL',
        lancarNoTitular: false,
        periodicidade: 'MENSAL'
    },
    listTipoFaixa: [],
}
